
import { Component, Vue, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { NETWORKAUDIAPI } from '@/api/network'
import { getuserCurrentApp } from '@/utils/cookies'
import { timestampToDate } from '@/utils/commonFunc'

@Component({
  components: {
  }
})
export default class Dashboard extends Vue {
  private users_table_data: any = [];
  private networkSLAData =
    {
      network_type_6_sla: {
        avg_deal_time: 0,
        all_deal_time: 0
      },
      network_type_7_sla: {
        avg_deal_time: 0,
        all_deal_time: 0
      },
      network_type_8_sla: {
        avg_deal_time: 0,
        all_deal_time: 0
      },
      all_type_finish_times: 0,
      network_type_zhanbi_and_count: {
        all_network_ts_count: 2,
        network_yunwei_count: 0,
        network_xuqiu_count: 0,
        network_biangeng_count: 0,
        network_xuqiu_ar_result: 0,
        network_yunwei_ar_result: 0.0,
        network_biangeng_ar_result: 0.0,
        total_network_ticket_usercount: 0
      },
      users_table_data: []
    }

  // navbar日期值
  get navbarDate() {
    return AppModule.navbarDate.length === 0
      ? [
        timestampToDate(new Date().getTime() - 3600 * 1000 * 24 * 7),
        timestampToDate(new Date().getTime())
      ]
      : AppModule.navbarDate
  }

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  @Watch('navbarDate')
  private onNavbarDateChange() {
    this.getAllNetwokTsData()
  }

  mounted() {
    AppModule.SetShowNavbarDate(true)
    this.getAllNetwokTsData()
  }

  private expireTimeOption: object = {
    disabledDate(time: any) {
      return time.getTime() > Date.now()
    }
  };

  // SLA获取
  private getAllNetwokTsData() {
    const commonParams = {
      from: this.navbarDate ? this.navbarDate[0] : '',
      to: this.navbarDate ? this.navbarDate[1] : ''
    }
    const networkTsData = NETWORKAUDIAPI.getNetworkTsData({
      app_id: 3,
      ...commonParams
    })
    return Promise.all([networkTsData]).then((res) => {
      this.networkSLAData = res[0].data
    })
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private handleChangeSelect() {

  }
}
